export default __webpack_public_path__ + "static/media/newblp_calendar.cb1d260f.svg";